// extracted by mini-css-extract-plugin
module.exports = {"thecomp":"EnergizeElectricity_thecomp__cNLla","swiperTool":"EnergizeElectricity_swiperTool__y0yFG"};